<template>
  <div>
    <el-row>
      <el-col :span="24" class="form-container">
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="SKU编码：">
            <el-input size="medium" v-model="searchForm.SKU_CODE" clearable></el-input>
          </el-form-item>
          <el-form-item label="SKU名称：">
            <el-input size="medium" v-model="searchForm.SKU_NAME" clearable></el-input>
          </el-form-item>
          <el-form-item label="供应商：">
            <el-select size="medium" filterable v-model="searchForm.TC_COMPANY" placeholder="请选择供应商" :clearable="true">
              <el-option v-for="item in companys" :key="item.SUPPLIER_ID" :label="item.NAME" :value="item.SUPPLIER_ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期范围：">
            <el-date-picker size="medium" v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels
                            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-button size="medium" type="primary" @click="doQueryTable()">筛选</el-button>
        </el-form>
      </el-col>
    </el-row>
    <el-table :data="tableData" style="width: 100%" border stripe>
      <el-table-column prop="index" label="序号" width="80" type="index"></el-table-column>
      <el-table-column prop="COMPANY_NAME" label="供应商"></el-table-column>
      <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
      <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
      <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
      <el-table-column v-if="PRICE_MODE == 2" prop="PRICE" label="价格"></el-table-column>
      <el-table-column v-if="PRICE_MODE == 2" prop="START_DAY" label="开始时间"></el-table-column>
      <el-table-column v-if="PRICE_MODE == 2" prop="END_DAY" label="结束时间"></el-table-column>
      <el-table-column v-if="PRICE_MODE == 1" prop="CURRENT_PRICE" label="当期价格"></el-table-column>
      <el-table-column v-if="PRICE_MODE == 1" prop="NEXT_PRICE" label="下期价格"></el-table-column>
      <el-table-column v-if="PRICE_MODE == 1" prop="NEXT_EFFECTIVE_DATE" label="下期生效日期"></el-table-column>
    </el-table>
    <div class="pagination_box" v-show="total_count > 10">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="total_count">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { haveGYSFun } from 'api/shopOrderManage';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      loading: false,
      // 供应商列表
      companys: [],
      // 搜索
      searchForm: {},
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total_count: 0,
      PRICE_MODE: sessionStorage.getItem('PRICE_MODE'),
    };
  },

  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    this.queryCustomer();
    if (this.PURCHASE_PRICE_INQUIRY_CONDITION.CONDITION) {
      this.searchForm = this.PURCHASE_PRICE_INQUIRY_CONDITION.CONDITION;
      this.currentPage = this.PURCHASE_PRICE_INQUIRY_CONDITION.CURRENT_PAGE;
    }
    this.doQueryTable();
  },
  computed: {
    // 上一次的搜索结果和条件
    PURCHASE_PRICE_INQUIRY_CONDITION() {
      return this.$store.state.PURCHASE_PRICE_INQUIRY_CONDITION;
    },
  },
  methods: {
    // 拉取供应商信息
    queryCustomer() {
      haveGYSFun()
        .then((result) => {
          if (result.length !== 0) {
            this.companys = result[0].list;
            this.customers = result[0].list;
          } else {
            this.companys = [];
            this.customers = [];
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 筛选
    doQueryTable() {
      const params = {
        SERVICE_ID: '10041',
        OTYPE: 37,
        PAGE_SIZE: this.pageSize,
        PAGE_INDEX: this.currentPage - 1,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.SKU_CODE) {
        params.PRODUCT_CODE = this.searchForm.SKU_CODE;
      }
      if (this.searchForm.SKU_NAME) {
        params.PRODUCT_NAME = this.searchForm.SKU_NAME;
      }
      if (this.searchForm.TC_COMPANY) {
        params.SUPPLIER_ID = this.searchForm.TC_COMPANY;
      }
      if (this.searchForm.DAY_INTERVAL) {
        [params.START_DAY, params.END_DAY] = this.searchForm.DAY_INTERVAL;
      }
      http.post(params).then((res) => {
        if (res.length === 0) {
          this.$message.show({ text: '暂无数据', type: 'warning' });
          this.tableData = [];
          this.total_count = 0;
        } else {
          this.tableData = res[0].LIST;
          this.total_count = res[0].TOTAL_COUNT;
          this.$store.dispatch('SET_PURCHASE_PRICE_INQUIRY_CONDITION', {
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
          });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.doQueryTable();
    },
  },

};
</script>
<style scoped>
.pagination_box {
  float: right;
  margin-top: 10px;
}
.form-container {
  display: flex;
}

.form-item {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/priceManagement/purchasePriceInquiry.vue